import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next"; 

import { Button } from "@/components/index";

import { getLocale } from "@/utils/utils";
import { I18N_NAMESPACE } from "@/shared/utils/multilang/constants";

import styles from "./404.module.scss";

const Page404 = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["not-found-container"]}>
      <h1 className={styles["not-found-title"]}>404</h1>
      <h3 className={styles["not-found-subtitle"]}>{t("page404")}</h3>
      <Button
        rootTagName="a"
        href="/"
        className={styles["not-found-button"]}
      >
        {t("goToMainPage")}
      </Button>
    </div>
  );
};

// need server side module because it's a separate page
export const getStaticProps = async (context) => {
  const { locale } = getLocale(context);

  return {
    props: {
      ...(await serverSideTranslations(locale, [I18N_NAMESPACE.common])),
    },
  };
};

export default Page404;
